import { render, staticRenderFns } from "./batch-form-tm-ck.vue?vue&type=template&id=65063b40&scoped=true&"
import script from "./batch-form-tm-ck.vue?vue&type=script&lang=js&"
export * from "./batch-form-tm-ck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65063b40",
  null
  
)

export default component.exports